//@ts-nocheck
import { useEffect, useState, createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../hooks/useAppDispatch';
import { fetchJobDetails } from '../store/slices/jobs/jobSlice';

const JobDetailsContext = createContext({
  jobDetails1: null,
  loading1: false,
  error1: null,
  is4041: false,
});

export const useJobDetails = () => useContext(JobDetailsContext);

const JobDetailsProvider = ({ children }) => {
  const { base_slug, jobId } = useParams();
  const dispatch = useAppDispatch();

  const [jobDetails1, setJobDetails1] = useState(null);
  const [loading1, setLoading1] = useState(false);
  const [error1, setError1] = useState(null);
  const [is4041, setIs4041] = useState(false);


  useEffect(() => {
    if (!base_slug || !jobId) return;

    setIs4041(false);
    setLoading1(true);
    setError1(null);

    dispatch(fetchJobDetails({ baseSlug: base_slug, jobId }))
      .unwrap()
      .then((data) => setJobDetails1(data))
      .catch((error) => {
        if (error?.data?.statusCode === 404) {
          setIs4041(true);
        } else {
          setError1(error);
        }
      })
      .finally(() => setLoading1(false));
  }, [base_slug, jobId]);

  return (
    <JobDetailsContext.Provider value={{ jobDetails1, loading1, error1, is4041 }}>
      {children}
    </JobDetailsContext.Provider>
  );
};

export default JobDetailsProvider;
